/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
/* eslint-enable import/no-extraneous-dependencies */

import cardStyles from '../../pageComponents/card.module.css';
import styles from './hero.module.css';

const Hero = props => (
  <div className={`${styles.heroContainer}`}>
    <div className={`${styles.hero} ${styles[props.color]} ${props.gradient ? styles.gradient : ''}`}>
      <div className={styles.heroBody}>
        <h1 className={styles.title}>
          {props.children}
        </h1>
        <h2 className="subtitle">
          {props.subtitle}
        </h2>
      </div>
    </div>
  </div>
);

Hero.propTypes = {
  subtitle: PropTypes.string,
  children: PropTypes.string.isRequired,
  color: PropTypes.string,
  gradient: PropTypes.bool,
};

Hero.defaultProps = {
  subtitle: '',
  color: 'primary',
  gradient: false,
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/hero/index.jsx